package api.service.visitScheduler

import api.data.DataVisitSchedule
import api.data.toDataVisitSchedule
import dev.gitlive.firebase.firestore.Direction
import dev.gitlive.firebase.firestore.FieldValue
import dev.gitlive.firebase.firestore.FirebaseFirestoreException
import firebaseFirestore
import kotlinx.css.data

class ImplServiceVisitScheduler() : ServiceVisitScheduler{
    override suspend fun getVisitSchedules(): ArrayList<DataVisitSchedule>? {
        val arrayVisitSchedule: ArrayList<DataVisitSchedule>? = ArrayList<DataVisitSchedule>()
        try {
            firebaseFirestore.collection("VisitSchedule").orderBy("timestamp", Direction.ASCENDING)
                .get().documents.forEach { documentSnapshot ->
                    if (documentSnapshot.exists){

                        arrayVisitSchedule?.add(documentSnapshot.toDataVisitSchedule())
                    } else {
                        return null
                    }
                }
        } catch (e: FirebaseFirestoreException){
            throw e
        }
        return arrayVisitSchedule

    }

    override suspend fun updateVisitSchedules(dataVisitSchedule: DataVisitSchedule): Boolean {
        try {

            firebaseFirestore.collection("VisitSchedule").document(dataVisitSchedule.id.toString())
                .set(dataVisitSchedule)
            return true
        } catch (e: FirebaseFirestoreException){
            throw e
        }
    }

    override suspend fun createVisitSchedule(dataVisitSchedule: DataVisitSchedule): Boolean {
        try {
            val hashMap = hashMapOf(
                "id" to dataVisitSchedule.id,
                "name" to dataVisitSchedule.name,
                "email" to dataVisitSchedule.email,
                "date" to dataVisitSchedule.date,
                "propertyId" to dataVisitSchedule.propertyId,
                "propertyLocation" to dataVisitSchedule.propertyLocation,
                "timestamp" to FieldValue.serverTimestamp,
                "visitOn" to dataVisitSchedule.visitOn
            )
            firebaseFirestore.collection("VisitSchedule").document(dataVisitSchedule.id.toString())
                .set(hashMap)
            return true
        } catch (e: FirebaseFirestoreException){
            throw e
        }
    }
}